import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Col, Form, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import TicketAPIs from "../../APIs/ticket";

/**
 * DriveEmailDocumentModal
 * - Same fields as DocumentModal: to, cc, subject, body
 * - NO ticket files, NO images, NO attachments selection UI
 * - On Send: calls props.onSend(payload) (you plug your different API here)
 */
const DriveEmailDocumentModal = (props) => {
  const { ticketIds, userId } = props;

  const [to, setTo] = useState(props?.to || "");
  const [cc, setCc] = useState(props?.cc || "");
  const [subject, setSubject] = useState(
    Array.isArray(props?.subject)
      ? props.subject.join(", ")
      : props?.subject || "",
  );
  const [body, setBody] = useState(props?.body || "");

  const [isSending, setIsSending] = useState(false);

  const handleToChange = (e) => setTo(e.target.value);
  const handleCcChange = (e) => setCc(e.target.value);
  const handleSubjectChange = (e) => setSubject(e.target.value);
  const handleBodyChange = (e) => setBody(e.target.value);

  const handleSendEmail = async () => {
    let sendmail;

    try {
      setIsSending(true);
      sendmail = await TicketAPIs.drivewayendEmail({
        ticketIds: ticketIds,
        userId: props?.userId,
        to: to,
        ccEmail: cc?.trim() ? cc.trim() : undefined,
        subject: subject.toString(),
        body: body,
      });

      if (sendmail.data.success) {
        toast.success("Email sent successfully!");
      }
    } catch (err) {
      if (!sendmail.data.success) {
        toast.error("Error in sending email!");
      }
      toast.error(`Error while uncompleting ticket`);
    } finally {
      setIsSending(false);
      props.onHide();
    }
  };

  // When modal opens or subject changes, refresh fields from props
  useEffect(() => {
    if (!props.show) return;

    setTo(props?.to || "");
    setCc(props?.cc || "");
    setSubject(
      Array.isArray(props?.subject)
        ? props.subject.join(", ")
        : props?.subject || "",
    );
    setBody(props?.body || "");
  }, [props.show, props.to, props.cc, props.subject, props.body]);

  return (
    <Modal {...props} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <h6 className="mb-0">Send Email To Region</h6>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Row className="align-items-center mb-1">
            <Col sm="2">
              <b>To:</b>
            </Col>
            <Col sm="10">
              <Form.Group className="from-group">
                <Form.Control
                  type="email"
                  placeholder="example@gmail.com"
                  value={to}
                  onChange={handleToChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="align-items-center mb-1">
            <Col sm="2">
              <b>CC:</b>
            </Col>
            <Col sm="10">
              <Form.Group className="from-group">
                <Form.Control
                  type="email"
                  value={cc}
                  onChange={handleCcChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="align-items-center mb-1">
            <Col sm="2">
              <b>Subject:</b>
            </Col>
            <Col sm="10">
              <Form.Group className="from-group">
                <Form.Control
                  type="text"
                  placeholder="Subject"
                  value={subject}
                  onChange={handleSubjectChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-1">
            <Col sm="2">
              <b>Body:</b>
            </Col>
            <Col sm="10">
              <Form.Group className="from-group">
                <Form.Control
                  type="text"
                  as="textarea"
                  rows={5}
                  value={body}
                  onChange={handleBodyChange}
                />
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button disabled={isSending} onClick={handleSendEmail}>
          {isSending ? "Sending..." : "Send Email"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DriveEmailDocumentModal;